module.exports = __webpack_public_path__ + "assets/img/logo.b58fe009.png";